var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", [_vm._v(_vm._s(_vm.model.Step4aTitle))]),
        _vm._v(" "),
        _c("p", { staticClass: "qualifier-tool-subheader" }, [
          _vm._v(_vm._s(_vm.model.Step4aSubTitle))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.nextStepValidation($event)
          }
        }
      },
      [
        _c("div", { staticClass: "row qualifier-tool-form-row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-block d-md-flex justify-content-center qualifier-tool-form-row-container"
            },
            [
              _c("div", { staticClass: "qualifier-tool-form-group-alt" }, [
                _c(
                  "div",
                  {
                    staticClass: "qualifier-tool-question-input-container",
                    class: {
                      valid: _vm.fields.FirstName && _vm.fields.FirstName.valid,
                      active: _vm.firstName
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.firstName,
                          expression: "firstName"
                        }
                      ],
                      staticClass: "qualifier-tool-question-input",
                      attrs: {
                        name: "FirstName",
                        type: "text",
                        id: "Firstname"
                      },
                      domProps: { value: _vm.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "Firstname" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.model.Step4FirstName))])
                    ]),
                    _vm._v(" "),
                    _vm.vErrors.first("FirstName")
                      ? _c("span", [_vm._v(_vm._s(_vm.model.RequiredMessage))])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "qualifier-tool-form-group-alt" }, [
                _c(
                  "div",
                  {
                    staticClass: "qualifier-tool-question-input-container",
                    class: {
                      valid: _vm.fields.LastName && _vm.fields.LastName.valid,
                      active: _vm.lastName
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lastName,
                          expression: "lastName"
                        }
                      ],
                      staticClass: "qualifier-tool-question-input",
                      attrs: { name: "LastName", type: "text", id: "Lastname" },
                      domProps: { value: _vm.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.lastName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "Lastname" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.model.Step4LastName))])
                    ]),
                    _vm._v(" "),
                    _vm.vErrors.first("LastName")
                      ? _c("span", [_vm._v(_vm._s(_vm.model.RequiredMessage))])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "qualifier-tool-form-group-alt" }, [
                _c(
                  "div",
                  {
                    staticClass: "qualifier-tool-question-input-container",
                    class: {
                      valid: _vm.emailValid && _vm.fields.Email.valid,
                      active: _vm.email,
                      invalid:
                        _vm.vErrors.first("Phone") && _vm.phoneLengthError
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "email",
                          expression: "'email'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      ref: "Email",
                      staticClass: "qualifier-tool-question-input",
                      attrs: { name: "Email", type: "text", id: "Email" },
                      domProps: { value: _vm.email },
                      on: {
                        blur: function($event) {
                          _vm.emailValid = _vm.email
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "Email" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.model.Step4Email))])
                    ]),
                    _vm._v(" "),
                    _vm.vErrors.first("Email")
                      ? _c("span", [_vm._v(_vm._s(_vm.vErrors.first("Email")))])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.email
                  ? _c(
                      "div",
                      {
                        staticClass: "qualifier-tool-question-input-container",
                        class: {
                          valid:
                            _vm.fields.ConfirmEmail &&
                            _vm.fields.ConfirmEmail.valid,
                          active: _vm.confirmEmail
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email|confirmed:Email",
                              expression: "'required|email|confirmed:Email'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmEmail,
                              expression: "confirmEmail"
                            }
                          ],
                          staticClass: "qualifier-tool-question-input",
                          attrs: {
                            name: "ConfirmEmail",
                            type: "text",
                            id: "ConfirmEmail"
                          },
                          domProps: { value: _vm.confirmEmail },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirmEmail = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "ConfirmEmail" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.model.Step4ConfirmEmail))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.vErrors.has("ConfirmEmail")
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.vErrors.first("ConfirmEmail")))
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "qualifier-tool-form-group-alt" }, [
                _c(
                  "div",
                  {
                    staticClass: "qualifier-tool-question-input-container",
                    class: {
                      valid: _vm.fields.Phone && _vm.fields.Phone.valid,
                      active: _vm.phone,
                      invalid:
                        _vm.vErrors.first("Phone") && _vm.phoneLengthError
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:10|max:10|",
                          expression: "'required|min:10|max:10|'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phone,
                          expression: "phone"
                        }
                      ],
                      ref: "Phone",
                      staticClass: "qualifier-tool-question-input",
                      attrs: {
                        name: "Phone",
                        type: "text",
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        oninput:
                          "this.value = this.value.replace(/[^0-9]/g, '');",
                        id: "Phone",
                        onkeydown:
                          "return ( event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) || (event.keyCode>34 && event.keyCode<40) || (event.keyCode==46) && event.keyCode != 32 && !(event.keyCode == 57 && event.shiftKey) && !(event.keyCode == 48 && event.shiftKey))"
                      },
                      domProps: { value: _vm.phone },
                      on: {
                        blur: _vm.handlePhoneLength,
                        paste: function($event) {
                          return _vm.handleOnPaste($event, false)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phone = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "Phone" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.model.Step4Phone))])
                    ]),
                    _vm._v(" "),
                    _vm.vErrors.first("Phone")
                      ? _c("span", [_vm._v(_vm._s(_vm.vErrors.first("Phone")))])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.phone
                  ? _c(
                      "div",
                      {
                        staticClass: "qualifier-tool-question-input-container",
                        class: {
                          valid:
                            _vm.fields.ConfirmPhone &&
                            _vm.fields.ConfirmPhone.valid,
                          active: _vm.confirmPhone
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:10|max:10|confirmed:Phone",
                              expression:
                                "'required|min:10|max:10|confirmed:Phone'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmPhone,
                              expression: "confirmPhone"
                            }
                          ],
                          staticClass: "qualifier-tool-question-input",
                          attrs: {
                            name: "ConfirmPhone",
                            type: "text",
                            inputmode: "numeric",
                            pattern: "[0-9]*",
                            oninput:
                              "this.value = this.value.replace(/[^0-9]/g, '');",
                            id: "ConfirmPhone",
                            onkeydown:
                              "return ( event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) || (event.keyCode>34 && event.keyCode<40) || (event.keyCode==46) && event.keyCode != 32 && !(event.keyCode == 57 && event.shiftKey) && !(event.keyCode == 48 && event.shiftKey))"
                          },
                          domProps: { value: _vm.confirmPhone },
                          on: {
                            paste: function($event) {
                              return _vm.handleOnPaste($event, true)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirmPhone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "ConfirmPhone" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.model.Step4ConfirmPhone))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.vErrors.first("ConfirmPhone")
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.vErrors.first("ConfirmPhone")))
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row d-flex justify-content-center qualifier-tool-footer"
          },
          [
            _c(
              "button",
              {
                staticClass: "qualifier-tool-btn",
                attrs: { type: "submit", disabled: _vm.disableSubmit }
              },
              [_vm._v(_vm._s(_vm.model.SubmitButtonText) + "*")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", {
              staticClass: "qualifier-tool-footer-text",
              domProps: { innerHTML: _vm._s(_vm.model.Step4FooterText) }
            })
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "qualifier-tool-status-bar" }, [
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("1")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "qualifier-tool-status-number qualifier-tool-status-number-active"
          },
          [_vm._v("2")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "qualifier-tool-status-number" }, [
          _vm._v("3")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }